import { render, staticRenderFns } from "./set-config.vue?vue&type=template&id=0e4adccf&"
import script from "./set-config.vue?vue&type=script&lang=js&"
export * from "./set-config.vue?vue&type=script&lang=js&"
import style0 from "./set-config.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports